import type { NodeRenderer } from '@contentful/rich-text-react-renderer';
import React from 'react';

const AssetHyperlink: NodeRenderer = (node, children) => {
  const url = node?.data?.target?.fields?.file?.url;
  return url ? <a href={url}>{children}</a> : null;
};

export default AssetHyperlink;
